import React from 'react';
import withIcon from '../utilities/withIcon';

const IconVariable = () => {
  return (
    <g>
      <path d="m1.051 0 4.95.006A.75.75 0 0 1 6.1 1.5l-.102.006L1.5 1.501V14.5H6a.75.75 0 0 1 .743.647l.007.102a.75.75 0 0 1-.648.744L6 15.999 1.05 16a1.05 1.05 0 0 1-1.044-.936L0 14.95V1.05C0 .51.41.064.936.007L1.05 0zm8.95.01 4.95.007c.541 0 .986.41 1.043.936l.006.114V14.95c0 .541-.41.987-.936 1.044L14.95 16H10a.75.75 0 0 1-.102-1.494L10 14.5l4.5.001V1.516L9.999 1.51a.75.75 0 0 1-.742-.649L9.25.76a.75.75 0 0 1 .751-.749z" />
    </g>
  );
};

export default withIcon(IconVariable);
